import { IconComponentProps } from '@typings';

export const ListViewTemplate = (props: IconComponentProps) => {
  return (
    <svg viewBox="0 0 80 114" fill="none" {...props}>
      <g clipPath="url(#prefix__clip0_10_4229)">
        <path d="M0 0h80v114H0V0z" fill="#fff" />
        <path d="M.5.496h79v113.008H.5V.496z" stroke="#E5E5E5" />
        <path d="M7.785 8.957h12.817v17.806H7.785V8.957z" fill="#CCC" />
        <path d="M27.067 8.957h16.718v5.072H27.067V8.957zM27.067 18.086h29.98v8.677h-29.98v-8.677z" fill="#E5E5E5" />
        <path d="M8.054 34.743H20.87v17.806H8.054V34.743z" fill="#CCC" />
        <path d="M27.335 34.743h16.718v5.071H27.335v-5.071zM27.335 43.871h29.98v8.678h-29.98v-8.678z" fill="#E5E5E5" />
        <path d="M8.054 60.529H20.87v17.806H8.054V60.529z" fill="#CCC" />
        <path d="M27.335 60.529h16.718V65.6H27.335v-5.071zM27.335 69.657h29.98v8.678h-29.98v-8.678z" fill="#E5E5E5" />
        <path d="M8.054 86.314H20.87v17.807H8.054V86.314z" fill="#CCC" />
        <path d="M27.335 86.314h16.718v5.072H27.335v-5.072zM27.335 95.443h29.98v8.678h-29.98v-8.678z" fill="#E5E5E5" />
      </g>
      <defs>
        <clipPath id="prefix__clip0_10_4229">
          <path fill="#fff" d="M0 0h80v114H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
